import { createAsyncThunk } from '@reduxjs/toolkit'
import axios from 'axios'
import CategoryService from '../../../common/category/core/service'
import EventEmitter, {
  SHOW_POPUP_CONFIRMATION,
} from '../../../helpers/EventEmitter'
import UserManagementService from '../../store/services/UserManagementService'

export const getUserProfile = createAsyncThunk(
  'userManagement/getUserProfile',
  async (data, { rejectWithValue }) => {
    try {
      const response = await UserManagementService.getUserProfile(data)
      if (response.success) {
        return response.data
      }
      return rejectWithValue({ loading: false })
    } catch (error) {
      if (axios.isCancel(error)) {
        return rejectWithValue({ loading: true })
      }
      return rejectWithValue({ loading: false })
    }
  },
)

export const postUpdateUserProfileRequest = createAsyncThunk(
  'userManagement/postUpdateUserProfileRequest',
  async (params, { rejectWithValue }) => {
    try {
      const response = await UserManagementService.postUpdateUserProfileRequest(
        params,
      )
      if (response?.success) {
        EventEmitter.dispatch(
          SHOW_POPUP_CONFIRMATION,
          'userProfile.SUCCESS_MESSAGE',
        )
        return response
      }
    } catch (error) {
      return rejectWithValue(error)
    }
  },
)

export const putUserProfile = createAsyncThunk(
  'userManagement/putUserProfile',
  async (params, { rejectWithValue }) => {
    try {
      const response = await UserManagementService.putUserProfile(params)
      if (response?.success) {
        EventEmitter.dispatch(
          SHOW_POPUP_CONFIRMATION,
          'userProfile.UPDATED_SUCCESS',
        )
        return response
      }
    } catch (error) {
      return rejectWithValue(error)
    }
  },
)

export const getJobTitles = createAsyncThunk(
  'userManagement/getJobTitles',
  async (params) => {
    const response = await CategoryService.getJobTitles(params)
    return response.data
  },
)

export const getCountries = createAsyncThunk(
  'userManagement/getCountries',
  async (params) => {
    const response = await CategoryService.getCountries(params)
    return response.data
  },
)

export const getUserProfileFields = createAsyncThunk(
  'userManagement/getUserProfileFields',
  async (params) => {
    const response = await UserManagementService.getUserProfileFields(params)
    return response.data
  },
)
